import script from "./IconedText.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconedText.vue?vue&type=script&lang=ts&setup=true"

import "./IconedText.vue?vue&type=style&index=0&id=9e1441cc&lang=less"

const __exports__ = script;

export default __exports__